/**
 * ReagentDateEditor — inline date picker for "bottle opened on" (bonus F).
 *
 * No localStorage — parent owns state via useReagentDates hook.
 */
import { useState } from 'react';

export interface ReagentDateEditorProps {
  kitSlug: string;
  currentDate?: string;
  onChange(iso: string | null): void;
}

export function ReagentDateEditor({
  currentDate,
  onChange,
}: ReagentDateEditorProps) {
  const [date, setDate] = useState(currentDate ?? '');

  const handleSave = () => {
    if (date) {
      onChange(date);
    }
  };

  const handleClear = () => {
    setDate('');
    onChange(null);
  };

  return (
    <div className="p-3 bg-slate-700/50 rounded-lg space-y-2" onClick={(e) => e.stopPropagation()}>
      <label className="block text-xs font-medium text-slate-300">
        Bottle opened on:
      </label>
      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        className="block w-full rounded border-slate-600 bg-slate-800 text-slate-200 text-sm px-2 py-1 focus:border-cyan-500 focus:ring-cyan-500"
      />
      <div className="flex gap-2">
        <button
          onClick={handleSave}
          disabled={!date}
          className="px-3 py-1 rounded text-xs font-semibold bg-cyan-600 text-white hover:bg-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Save
        </button>
        <button
          onClick={handleClear}
          className="px-3 py-1 rounded text-xs font-semibold bg-slate-600 text-slate-300 hover:bg-slate-500 transition-colors"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
